
import { QBtn } from 'quasar';
import { PropType, computed, defineComponent } from 'vue';

// import { useBtnProps } from 'quasar/src/components/btn/use-btn.js';
import { BtnTypes } from './button';

export type BtnType =
  | 'brand-error'
  | 'brand-info'
  | 'brand-warning'
  | 'brand-success'
  | 'secondary'
  | 'secondary-error'
  | 'secondary-info'
  | 'secondary-warning'
  | 'secondary-success'
  | 'light'
  | 'light-error'
  | 'light-info'
  | 'light-warning'
  | 'light-success'
  | 'icon'
  | 'icon-error'
  | 'icon-info'
  | 'icon-warning'
  | 'icon-success';

export default defineComponent({
  name: 'SBtn',
  components: {
    QBtn,
  },
  props: {
    // ...useBtnProps,
    type: {
      required: false,
      type: String as PropType<BtnTypes>,
      default: 'brand',
    },
    fat: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  setup(props, { attrs, slots }) {
    // console.log('props', props);
    // console.log('attrs', attrs);

    const classes = computed(() => {
      let result = 's-btn ';
      result += `${props?.type === 'brand-error' ? 'error ' : ''} `;
      result += `${props?.type === 'brand-info' ? 'info ' : ''} `;
      result += `${props?.type === 'brand-warning' ? 'warning ' : ''} `;
      result += `${props?.type === 'brand-success' ? 'success ' : ''} `;

      result += `${props?.type === 'secondary' ? 's-btn__outline' : ''} `;
      result += `${props?.type === 'secondary-error' ? 's-btn__outline error' : ''} `;
      result += `${props?.type === 'secondary-info' ? 's-btn__outline info' : ''} `;
      result += `${props?.type === 'secondary-warning' ? 's-btn__outline warning' : ''} `;
      result += `${props?.type === 'secondary-success' ? 's-btn__outline success' : ''} `;

      result += `${props?.type === 'light' ? 's-btn__light' : ''} `;
      result += `${props?.type === 'light-error' ? 's-btn__light error' : ''} `;
      result += `${props?.type === 'light-info' ? 's-btn__light info' : ''} `;
      result += `${props?.type === 'light-warning' ? 's-btn__light warning' : ''} `;
      result += `${props?.type === 'light-success' ? 's-btn__light success' : ''} `;

      result += `${props?.type === 'icon' ? 's-btn__icon' : ''} `;
      result += `${props?.type === 'icon-error' ? 's-btn__icon error' : ''} `;
      result += `${props?.type === 'icon-info' ? 's-btn__icon info' : ''} `;
      result += `${props?.type === 'icon-warning' ? 's-btn__icon warning' : ''} `;
      result += `${props?.type === 'icon-success' ? 's-btn__icon success' : ''} `;

      result += `${props?.fat ? 's-btn__fat' : ''} `;
      return result;
    });

    return { classes, slots };
  },
});
